module.exports = __webpack_public_path__ + "static/media/3DPPA35.fefc9a46.jpg";